import {toast} from "sonner"

export async function deleteHoursEndpoint(packageId) {
    const url = `${process.env.REACT_APP_API_URL}/admin/estudiante/personalizado/horas-compradas/eliminar/${packageId}`;
    const token = sessionStorage.getItem('token');

    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        const contentType = response.headers.get('content-type');
        const responseText = await response.text();

        if (!response.ok) {
            toast.error("Error al eliminar paquete de horas", responseText);    
            console.error('Server responded with:', responseText);
            throw new Error('Failed to delete hours package');
        }

        if (contentType && contentType.includes('application/json')) {
            toast.success("Paquete de horas eliminado con éxito");
            return JSON.parse(responseText);
        } else {
            console.log('Response is not JSON:', responseText);
            toast.success("Paquete de horas eliminado con éxito");
            return { message: responseText };
        }
    } catch (error) {
        console.error('Error deleting hours package:', error);
        throw error;
    }
}